import { SVGProps, Ref, forwardRef } from 'react';

export const GoogleGrayscaleSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.224 5.253c2.108 0 3.53.893 4.34 1.638l3.168-3.031C17.787 2.088 15.255 1 12.224 1 7.834 1 4.043 3.469 2.197 7.062l3.63 2.762a6.77 6.77 0 0 1 6.397-4.57"
                    fill="#7F858B"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M23 12.245c0-.905-.075-1.565-.237-2.25H12.225v4.083h6.186c-.125 1.014-.799 2.542-2.295 3.569l3.542 2.689c2.12-1.92 3.342-4.743 3.342-8.091"
                    fill="#8B9299"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.839 14.176A6.7 6.7 0 0 1 5.465 12c0-.758.137-1.491.362-2.175l-3.63-2.763A10.8 10.8 0 0 0 1 12c0 1.772.437 3.447 1.197 4.938z"
                    fill="#A3ABB2"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.225 23c3.03 0 5.574-.978 7.433-2.664l-3.542-2.69c-.948.648-2.22 1.1-3.891 1.1a6.74 6.74 0 0 1-6.386-4.57L2.21 16.938C4.056 20.53 7.835 23 12.225 23"
                    fill="#72777D"
                />
            </g>
        </g>
    </svg>
));
GoogleGrayscaleSize24Glyph.displayName = 'GoogleGrayscaleSize24Glyph';
